import React from 'react'
import { Box, Typography, Paper } from '@mui/material'
import {
  comparisonStyle,
  headlineStyle,
  titleCountStyle,
  titleStyle,
  updateTextStyle,
} from './AnalyticsStockCard.styles'
import { formatNumber, formatUnixTimeStampToDate } from '~/src/libs'
import { useTranslation } from 'react-i18next'

interface AnalyticsStockCardProps {
  label: string
  title: string
  count: number
  units: string
  comparisonText: string
  comparisonDiff: number | string | undefined
  updatedAt: number | undefined
}

export const AnalyticsStockCard: React.FC<AnalyticsStockCardProps> = ({
  label = '',
  title = '',
  count = 0,
  units = '台',
  comparisonText = '在庫前日対比',
  comparisonDiff = 0,
  updatedAt,
}) => {
  const { t } = useTranslation()
  return (
    <Paper sx={{ p: '20px' }}>
      <Typography component="h2" sx={headlineStyle}>
        {label}
      </Typography>
      <Typography component="p" sx={titleStyle}>
        {title}&nbsp;
        <Typography component="span" variant="h3" sx={titleCountStyle}>
          {formatNumber(count)}&nbsp;
        </Typography>
        {units}
      </Typography>

      <Typography sx={comparisonStyle}>
        ({comparisonText}:&nbsp;
        <Typography
          component="span"
          sx={{
            color: comparisonDiff < 0 ? 'green' : 'red',
          }}
        >
          {comparisonDiff < 0 ? `${comparisonDiff}` : `+${comparisonDiff}`}
          {units}
        </Typography>
        )
      </Typography>

      <Typography variant="caption" sx={updateTextStyle}>
        {t('dashboard.update_date_and_time')}：
        {updatedAt && formatUnixTimeStampToDate(updatedAt, 'yyyy/MM/dd h:mm')}
      </Typography>
    </Paper>
  )
}
